<template>
  <input v-on:click="onClick" type="checkbox" />
</template>

<script>
export default {
  name: "MultiSelectCheckbox",
  props: {
    data: {
      type: Object,
      default: null
    },
    clicked: {
      type: Function,
      default: null
    }
  },
  methods: {
    onClick: function(e) {
      if (this.clicked) this.clicked(e, this.data);
    }
  }
};
</script>

<style scoped></style>
